import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ThrowJsNullError',
  setup(__props) {


function throwError() {
    const element: HTMLElement = document.getElementById('NoElementIdFound');
    const k = element.getBoundingClientRect().height;
    console.log('height of element: ', k);
}


return { __sfc: true,throwError }
}

})